module.exports = __webpack_public_path__ + "img/YouPlusAnchorChallenger2020ZH-7.bbba8960.jpg";